import {PaymentItem as PaymentItemModel} from "../../models";
import style from "./Payment.module.css";
import {Alert, Col, Row} from "react-bootstrap";
import {IoChevronBack, IoChevronForward} from "react-icons/io5";
import PaymentItemGroup from "../../models/payment-item-group";
import axios from "axios";
import i18n from "../../i18n";
import {useNavigate, useParams} from "react-router";
import Summary from "../../models/summary";
import {useState} from "react";
import UseCreditPopup from "../Credit/UseCreditPopup/UseCreditPopup";
import {useTranslation} from "react-i18next";
import {FRAME, FRAME_WITHOUT_HEADERS, INTERNAL_FRAME, REDIRECT} from "../../Constants/viewType";
import ZeroCreditPopup from "../Credit/ZeroCreditPopup/ZeroCreditPopup";
import { logOrderSelectPaymentClickPay } from "../../logging/helpers/commonLoggingFunctions";
import postValidateApplePayMerchant from "../../Api/Requests/post-validate-apple-pay-merchant";
import postCheckoutApplePayPaymentData from "../../Api/Requests/post-checkout-apple-pay-payment-data";
import postCheckoutGooglePayPaymentData from "../../Api/Requests/post-checkout-google-pay-payment-data";

export interface Props {
    item: PaymentItemModel | PaymentItemGroup
    cartId: number;
    clearFix: boolean;
    cartSummary: Summary,
    payment_secret?:string,
    isDisabled:boolean,
    setIsDisabled:React.Dispatch<React.SetStateAction<boolean>>;

}

const PaymentItem = (props: Props) => {
    const [isPayingWithGooglePay, setIsPayingWithGooglePay] = useState(false);
    let {memberId, cartId, identification} = useParams();
    const {t} = useTranslation()
    const navigate = useNavigate();
    const [show, setShow] = useState<boolean>(false)
    const getIcon = (key: string) => {
        return require(`../../Assets/Images/Payments/${key}.png`)
    }
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const getIconList = (methods: PaymentItemModel[]) => {
        return methods.map((method) => {
            return <img src={getIcon(method.key)} className={style.item_sub_img} alt={''}/>
        })
    }

    const toggleShow = () => {
        setShow((oldShow) => {
            return !oldShow
        })
    }

    const pushPayment = (method_name : string) => {
        console.log('method_name',method_name);
        //logging
        if(props.cartId)
            logOrderSelectPaymentClickPay({id: props.cartId},method_name);
        //
        if (props.isDisabled)
        return

        props.setIsDisabled(true)

        const url = props.item.url
        const data = {
            ...props.item.postData,
            unified: true
        }


        /*-----------------------------
         *           REQUEST
         * ----------------------------*/
        // const postPushPaymentHttp = useHttp<DynamicObject>(configPushPaymentApi)
        // const requestPostPushPayment = postPushPaymentHttp.request
        //
        // postPushPaymentHttp.request = useCallback((args) => {
        //
        //     const success = (response: AxiosResponse) => {
        //
        //     }
        //     const error = (response: AxiosError) => {
        //     }
        //
        //     requestPostPushPayment({
        //         config: {
        //             url:url,
        //             data:data
        //         },
        //         callbacks: {
        //             success,
        //             error,
        //         }
        //     })
        // }, [url,data])


        let countryCode = localStorage.getItem('countryCode')
        if (countryCode == null || countryCode==undefined)
            countryCode = 'jo'

        setErrorMessage(null);
        axios.post(
            url,
            data,
            {
                headers: {
                    country: countryCode,
                    source: 'desktop',
                    "enforce-language": i18n.language
                }
            }
        ).then(response => {
            // if (props.item['key'] == 'MediaWorld') {
            //
            //     const url = 'f777631c2d77787'
            //     navigate(`/payment/internalFrame/${url}`)
            //     return
            // }

            // return


            if (props.item.viewType['type'] == FRAME || props.item.viewType['type'] ==  FRAME_WITHOUT_HEADERS) {

                const webView = ''
                navigate(`${process.env.REACT_APP_PAYMENT_DIR}/payment/${props.item.method_name}/${props.payment_secret}${webView}`, {
                    state: {
                        methodData: response.data,
                        label: props.item.label,
                        cartId: props.cartId,
                        cartSummary: props.cartSummary,
                        withoutHeaders: props.item.viewType['type'] == FRAME_WITHOUT_HEADERS,
                        url:props.item.url
                    },
                })
            } else if (props.item.viewType['type'] == REDIRECT) {

                window.location.href = response.data.redirectTo
            } else if (props.item.viewType['type'] == INTERNAL_FRAME) {
                navigate(`${process.env.REACT_APP_PAYMENT_DIR}/internalFrame`,{
                    state: {
                        data: response.data,
                        cartId:props.cartId

                    }
                })
            }
        }).catch(error => {
            console.error('Error in pushPayment:', error.response);
            if(error.response && error.response.data && error.response.data.errorMessage){
                setErrorMessage(error.response.data.errorMessage);
            }
        }).finally(() => {
            props.setIsDisabled(false)
        });
    }

    const cliqHandler = () => {
        if(cartId){
            logOrderSelectPaymentClickPay({id: +cartId},'Cliq');
        }
        navigate(`/cliq/${memberId}/${cartId}/${identification}/${props.payment_secret}`,{
            state: {
                cartId :props.cartId
            }
        })
    }
    
    const primotechHandler = () => {
        if(cartId){
            logOrderSelectPaymentClickPay({id: +cartId},'Primotech');
        }

        navigate(`/primotech/${memberId}/${cartId}/${identification}/${props.payment_secret}`,{
            state: {
                cartId :props.cartId
            }
        })
    }

    const loadGooglePayScript = (): Promise<void> => {
        return new Promise((resolve, reject) => {
            if ((window as any).google && (window as any).google.payments) {
                resolve();
                return;
            }
            const script = document.createElement("script");
            script.src = "https://pay.google.com/gp/p/js/pay.js";
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error("Failed to load Google Pay JS"));
            document.body.appendChild(script);
        });
    };

    const applePaySession = window.ApplePaySession;

    const onGooglePayButtonClick = async (item: any, paymentSecret: string) => {
        try {
            setIsPayingWithGooglePay(true); // 🔒 LOCK UI

            await loadGooglePayScript(); // wait for script

            const google = (window as any).google;
            if (!google?.payments?.api) {
                console.error("Google Pay API not available");
                return;
            } 

            const paymentsClient = new google.payments.api.PaymentsClient({
                environment: process.env.REACT_APP_CHECKOUT_INTEGRATION_GOOGLE_PAY_ENVIRONMENT
            });

            // --- Tokenization specification for Checkout.com ---
            const tokenizationSpecification = {
                type: "PAYMENT_GATEWAY",
                parameters: {
                    gateway: "checkoutltd",
                    gatewayMerchantId: process.env.REACT_APP_CHECKOUT_INTEGRATION_PUBLIC_KEY, // your Checkout.com public key
                },
            };

            // --- Payment data request ---
            const paymentDataRequest = {
                apiVersion: 2,
                apiVersionMinor: 0,
                allowedPaymentMethods: [
                    {
                        type: "CARD",
                        parameters: {
                            allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                            allowedCardNetworks: ["VISA", "MASTERCARD"],
                        },
                        tokenizationSpecification, // <-- MUST BE HERE inside allowedPaymentMethods
                    },
                ],
                transactionInfo: {
                    totalPriceStatus: "FINAL",
                    totalPrice: item.price.toString(), // use actual item price
                    currencyCode: item.googlePayCurrency,
                    countryCode: item.googlePayCountry || "AE",
                },
                merchantInfo: {
                    merchantName: "OpenSooq",
                    merchantId: 'BCR2DN5TT2HOVVTK'
                },
            };

            const paymentData = await paymentsClient.loadPaymentData(paymentDataRequest);
            const tokenData = paymentData.paymentMethodData.tokenizationData.token;

            const response = await postCheckoutGooglePayPaymentData({
                tokenData,
                paymentSecret,
            });
            
            if (response.data.paymentSuccess) {
                navigate(
                    `${process.env.REACT_APP_PAYMENT_DIR}/payment/${item.method_name}/failed/${paymentSecret}/${response.data.cartId}`
                );
            } else {
                navigate(
                    `${process.env.REACT_APP_PAYMENT_DIR}/payment/${item.method_name}/failed/${paymentSecret}/${response.data.cartId}`
                );
            }
        }catch (err: any) {
            if (err?.statusCode === "CANCELED" || err?.statusCode === "CANCELLED") {
                console.log("Google Pay cancelled by user");
            } else {
                console.error("Google Pay failed:", err);
            }
        } finally {
            setIsPayingWithGooglePay(false); // 🔓 UNLOCK UI
        }
    };

    
    const onApplePayButtonClick = (item : any,paymentSecret : string) => {
        if (!applePaySession || !applePaySession.canMakePayments()) {
          console.log("Apple Pay is not available on this device");
          return;
        }

        const request = {
          countryCode: item.countryCode,
          currencyCode: item.currency,
          supportedNetworks: ["visa", "masterCard", "amex"],
          merchantCapabilities: ["supports3DS"],
          total: {
            label: "OpenSooq",
            amount: item.price,
          },
        };
    
        const session = new applePaySession(3, request);
    
        session.onvalidatemerchant = (event: any) => {
            postValidateApplePayMerchant({ validationURL: event.validationURL }).then((response) => {
                session.completeMerchantValidation(response.data);
            }).catch((error) => {
                throw new Error(error);
            })
        }
        session.onpaymentauthorized = (event: any) => {
            try {
                var paymentData = event.payment.token.paymentData;
                paymentData['paymentSecret'] = paymentSecret;
                postCheckoutApplePayPaymentData(paymentData).then((response) => {
                    if (response.data.paymentSuccess) {
                        session.completePayment(applePaySession.STATUS_SUCCESS);
                        navigate(`${process.env.REACT_APP_PAYMENT_DIR}/payment/pending/${paymentSecret}`, { })
                    } else {
                        session.completePayment(applePaySession.STATUS_FAILURE);
                        navigate(`${process.env.REACT_APP_PAYMENT_DIR}/payment/${item.method_name}/failed/${paymentSecret}/${response.data.cartId}`, { })
                    }
                }).catch((error) => {
                    session.completePayment(applePaySession.STATUS_FAILURE);
                navigate(`${process.env.REACT_APP_PAYMENT_DIR}/payment/${item.method_name}/failed/${paymentSecret}/${paymentSecret}`, { })
                    throw new Error(error);
                })
            } catch (error) {
                session.completePayment(applePaySession.STATUS_FAILURE);
                throw new Error(error);
            }
        };
    
        session.begin();
    };

    return <>
        {isPayingWithGooglePay && (
        <div className={style.paymentOverlay}>
            <div className={style.loader}></div>
            <div className={style.loaderText}>
                {t('pleaseWait') || 'Processing payment...'}
            </div>
        </div>)}
        <div  dir={i18n.language=='en'?'ltr':'rtl'}>
        <div className={style.item_container} key={props.item.key} id={props.item.method_name === "CheckoutPayment" && props.item.key === 'GOOGLEPAY' && props.item.viewType.type == 'googlePaySDK' ? "gpay-button" : ""} onClick={() => {
            console.log('Clicked payment method:', props.item.viewType.type);
                if(props.item.method_name === "Credit"){
                    toggleShow()
                }else if(props.item.method_name === "Cliq" && props.item.viewType.type == 'internalFrame'){
                    cliqHandler()
                }else if(props.item.method_name === "Primotech" && props.item.viewType.type == 'internalFrame'){
                    primotechHandler();
                }else if(props.item.method_name === "CheckoutPayment" && props.item.key === 'APPLEPAY' && props.item.viewType.type == 'applePaySDK'){
                    onApplePayButtonClick(props.item,props.payment_secret)
                }else if(props.item.method_name === "CheckoutPayment" && props.item.key === 'GOOGLEPAY' && props.item.viewType.type == 'googlePaySDK'){
                    onGooglePayButtonClick(props.item,props.payment_secret)
                }else {
                    pushPayment(props.item.method_name)
                }
            }}>
                <div className={style.item_wrapper} >
                    <Row className={style.item_row}>
                        <Col className={`${style.item_col}`}>
                            <div className={`${i18n.language=='en'?'float-start':'float-end'} `}>
                            <span className={`${style.pad_text} ${style.size_text}`}>
                                {
                                    props.item.method_name === "Credit" ? t('wallet.payment.credit') : props.item.label
                                }
                            </span>
                            </div>
                            <div className={`${i18n.language=='en'?'float-end':'float-start'}`}>
                                <div className={style.holder_img}>
                                    <div className={style.item_img}>
                                        {
                                            props.item.method_name === "Credit" ?
                                                <span className={`${style.pad_text_right} ${style.size_text}`}
                                                        dangerouslySetInnerHTML={{
                                                            __html: props.item.method_name === "Credit" ? `<span class="${style.font_size_sm}">${props.item.wallet.local}</span> <span class="${style.font_size_sm}">${props.item.wallet.localCurrency}</span>` : ''
                                                        }}></span> : <div></div>
                                        }
                                        {
                                            !props.item.isGroup && "key" in props.item &&
                                            <img src={getIcon(props.item.key)} className={style.item_sub_img} alt={''}/>
                                        }

                                        {
                                            props.item.isGroup && "methods" in props.item && getIconList(props.item.methods)
                                        }
                                        {i18n.language=='en'?<IoChevronForward
                                            className={`${style.item_sub_img} ${style.blue_color}`}></IoChevronForward>:<IoChevronBack
                                            className={`${style.item_sub_img} ${style.blue_color}`}></IoChevronBack>
                                        }



                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                {!props.clearFix && <hr style={{marginTop:"10px" ,color:"lightgray"}}/>}

                {!props.clearFix ?'' : ''}
            </div>
            {props.item.method_name === 'Credit' ? props.item.showCreditPopup && show ? <UseCreditPopup payment_secret={props.payment_secret} invokeToggle={() => {toggleShow()}} invokePopup={show} wallet={props.item.wallet} summary={props.cartSummary}/> :
                <ZeroCreditPopup invokeToggle={() => { toggleShow() }} invokePopup={show} title={t('zeroBalance')} /> : <div></div>}
        </div>
        <Alert variant="danger" className="mt-3" show={!!errorMessage} onClose={() => setErrorMessage(null)} dismissible>
            {errorMessage}
        </Alert>
    </>
}

export default PaymentItem